<template>
  <div>
    <div v-if="showtoolbar" class="px-0">
      <b-row class="px-0 mt-0">
        <b-col cols="auto">
          <b-button-group class="z-0">
            <b-row align-h="start" no-gutters>
              <b-col class="gridtoolbar" cols="auto" v-for="(tool, index) in toolbar.filter((o) =>
                o.position.includes('toolbar')
              )" :key="index">
                <b-button v-if="tool.type == 'button' && tool.visible" :id="'toolClick' + tool.action" :size="tool.size"
                  :variant="tool.variant" :title="tool.title ? tool.title : toolLabel(tool)"
                  :squared="tool.squared ? 'squared' : null" :disabled="tool.disabled"
                  @click="toolClick($event, tool.action, checked_items)">
                  <!-- :disabled="
                    tool.action == 'paste'
                      ? $store.state.clipboard
                        ? false
                        : true
                      : tool.disabled
                  " -->
                  <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                  <span v-if="toolLabel(tool)" v-html="toolLabel(tool)"> </span>
                  <i v-if="tool.icon2" :class="tool.icon2"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-button-group>
        </b-col>
      </b-row>

      <div v-if="showfab" :class="fab_bar ? 'btn-group-fab active' : 'btn-group-fab'" role="group" aria-label="FAB Menu"
        @click="fab_bar = !fab_bar">
        <div>
          <button id="menu" type="button" class="btn btn-main btn-primary has-tooltip" data-placement="left">
            <!-- title="Menu" -->
            <i :class="fab_bar ? 'fa fa-times' : 'fa fa-bars'"></i>
          </button>
          <b-tooltip target="menu" placement="right">Click for actions</b-tooltip>
          <div v-for="(tool, index) in toolbar.filter((o) =>
            o.position.includes('toolbar')
          )" :key="index">
            <b-button :id="'fab_' + tool.action" type="button" class="btn btn-sub btn-outline-primary has-tooltip"
              data-placement="left" :style="'bottom: ' + bottom(index) + 'px'"
              @click="toolClick($event, tool.action, checked_items)">
              <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
              <!-- :title="tool.tooltip ? tool.tooltip : toolLabel(tool)" -->
            </b-button>
            <b-tooltip :target="'fab_' + tool.action" placement="right">{{
              tool.tooltip ? tool.tooltip : toolLabel(tool)
            }}</b-tooltip>
          </div>
        </div>
      </div>
    </div>
    <!-- {{items_}} -->
    <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
      <div class="px-0">
        <b-overlay :show="overlay_show" opacity=".9" v-click-outside="outside">
          <label v-if="title" class="text-left">{{ title }}</label>
          <table :class="classdivtable">
            <thead>
              <tr>
                <th v-if="selectmode == 'checkbox'" class="text-center w-30px">
                  <input id="allcheck" style="height: 15px; margin-top: 2px" type="checkbox" v-if="rows.length > 0"
                    @change="toggleAll" :checked="allAreChecked" />

                </th>
                <!-- <b-tooltip
                    :target="'allcheck'"
                    show
                    placement="top"
                    triggers="hover"
                    >Shift+Click to select a range.</b-tooltip
                  > -->
                <th style="width: 50px"></th>
                <th>
                  <table width="100%" class="nested">
                    <tr>
                      <td v-if="!cell.hidden" v-for="(cell, cindex) in fields" :key="'c_' + cindex"
                        :class="cell.class ? cell.class : null" :style="cell.style ? cell.style : null">
                        <div v-if="cell.clearable">
                          <div style="padding-right: 30px">
                            {{ cell.label }}
                          </div>
                        </div>
                        <div v-else>{{ cell.label }}</div>
                      </td>
                    </tr>
                  </table>
                </th>
                <th v-if="toolbar.filter((t) => t.position.includes('actions'))
                  .length > 0
                " class="actions">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- Rows carrying a record-unique uid are keyed by it so Vue never reuses an
                   inline editor component across different records (stale field state was
                   bleeding PO numbers onto other rows during server-side pagination - see
                   tp_server#20). Rows without a uid keep the positional key. -->
              <tr v-for="(row, rindex) in items_" :key="row.uid ? 'u_' + row.uid : 'r_' + rindex" :class="row.rowClass ? row.rowClass : null">
                <td v-if="selectmode == 'checkbox'" @click.stop="" class="text-center w-30px">
                  <input v-if="row.id" style="height: 13px" type="checkbox" @click="toggleRow($event, rindex)"
                    v-model="checked_items" :value="row" />
                </td>
                <td class="w-30px" style="padding-top: 1px !important">
                  <span class="small text-primary">{{ offset + rindex + 1 }}.
                  </span>
                  <i v-if="rowIcon(row)" :class="rowIcon(row)"></i>
                </td>

                <td>
                  <table width="100%" class="nested">
                    <tr>
                      <td v-if="!cell.hidden" v-for="(cell, cindex) in fields" :key="'c_' + cindex"
                        :class="cell.class ? cell.class : null" :style="cell.style ? cell.style : null">

                        <treeselect v-if="cell.type == 'treeselect' && cell.key == 'eventcode'
                        " :searchPromptText="cell.searchPromptText
                          ? cell.searchPromptText
                          : 'Type at least 4 chars...'
                          " :multiple="cell.multiple == true ? true : false" :async="true" :show-count="true"
                          :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                          :load-options="treeselect_loadEvent" v-model="items_[rindex][cell.key]">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>
                        <treeselect v-if="cell.type == 'treeselect' && cell.key == 'slac'" :searchPromptText="cell.searchPromptText
                          ? cell.searchPromptText
                          : 'Type at least 3 chars...'
                          " :multiple="cell.multiple == true ? true : false" :async="true" :show-count="true"
                          :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                          :load-options="treeselect_loadSLAC" v-model="items_[rindex][cell.key]">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>
                        <treeselect v-if="cell.type == 'treeselect' && cell.key == 'blac'" :searchPromptText="cell.searchPromptText
                          ? cell.searchPromptText
                          : 'Type at least 3 chars...'
                          " :multiple="cell.multiple == true ? true : false" :async="true" :show-count="true"
                          :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                          :load-options="treeselect_loadBLAC" v-model="items_[rindex][cell.key]">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>

                        <treeselect v-if="cell.type == 'treeselect' && cell.key == 'nlcode'" :searchPromptText="cell.searchPromptText
                          ? cell.searchPromptText
                          : 'Type at least 3 chars...'
                          " :multiple="cell.multiple == true ? true : false" :async="true" :show-count="true"
                          :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                          :load-options="treeselect_loadNLCode" v-model="items_[rindex][cell.key]">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>

                        <treeselect v-if="cell.type == 'treeselect' && cell.key == 'payby'" :searchPromptText="cell.searchPromptText
                          ? cell.searchPromptText
                          : 'Type at least 3 chars...'
                          " :multiple="cell.multiple == true ? true : false" :async="true" :show-count="true"
                          :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                          :load-options="treeselect_loadPAYBY" v-model="items_[rindex][cell.key]">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>

                        <treeselect v-if="cell.type == 'treeselect' && cell.key == 'vatrate'" :searchPromptText="cell.searchPromptText
                          ? cell.searchPromptText
                          : 'Type at least 3 chars...'
                          " :multiple="cell.multiple == true ? true : false" :async="true" :show-count="true"
                          :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                          :load-options="treeselect_loadVATRATE" v-model="items_[rindex][cell.key]">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>

                        <treeselect v-if="cell.type == 'treeselect' &&
                          (cell.key == 'routing' ||
                            cell.key == 'startcity' ||
                            cell.key == 'endcity')
                        " :searchPromptText="cell.searchPromptText
                          ? cell.searchPromptText
                          : 'Type at least 3 chars...'
                          " :multiple="cell.multiple == 'true' ? true : false" :async="true" :show-count="true"
                          :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                          :load-options="treeselect_loadIATA" v-model="items_[rindex][cell.key]">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>

                        <treeselect v-if="cell.type == 'treeselect'" v-model="items_[rindex][cell.key]"
                          :clearable="cell.clearable == true ? true : false" :options="cell.options"
                          :multiple="cell.multiple == true ? true : false" @select="$emit('changed', items_[rindex])"">
                        </treeselect>

                        <b-input-group>
                          <daterangepicker v-if="cell.type == 'daterangepicker'" :title="cell.label" size="sm"
                          :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true"
                          :linkedCalendars="true" :single-date-picker="cell.singleDatePicker
                            ? cell.singleDatePicker
                            : null
                            " :opens="cell.opens ? cell.opens : 'right'"
                          :disabled="cell.disabled == 'true' ? true : null" v-model="items_[rindex][cell.key]">
                          </daterangepicker>
                          <b-input-group-append>
                            <!-- <b-button
                            v-if="
                              cell.type == 'daterangepicker' &&
                              cell.clearable == 'true'
                            "
                            size="sm"
                            variant="outline-secondary"
                            @click="
                              items[rindex][cell.key] = {
                                startDate: null,
                                endDate: null,
                              }
                            "
                          >
                            <i class="fa fa-remove"></i>
                          </b-button> -->
                            <b-link v-if="cell.type == 'daterangepicker' &&
                              cell.clearable == 'true'
                            " class="mt-1 mx-2" @click="
                              items_[rindex][cell.key] = {
                                startDate: null,
                                endDate: null,
                              }
                              " title="Clear">
                              <i class="fa fa-remove text-dark"></i>
                            </b-link>
                          </b-input-group-append>
                          </b-input-group>

                          <b-input-group>
                            <b-form-input v-if="cell.type == 'text'" :id="'row_' + rindex + 'key_' + cell.key"
                              :title="cell.key == 'type' ? items_[rindex]['line_ri'] : cell.label" :placeholder="cell.placeholder ? cell.placeholder : null
                                " type="text" size="sm" :debounce="debounce"
                              :disabled="cell.disabled == 'true' ? true : null" :class="cell.class ? cell.class : null"
                              :list="cell.datalist ? cell.key : null" v-model="items_[rindex][cell.key]"
                              @input="$emit('changed', items_[rindex])"></b-form-input>
                            <div v-if="cell.datalist">
                              <datalist :id="cell.key">
                                <option v-for="celllist in cell.datalist" :key="celllist">
                                  {{ celllist }}
                                </option>
                              </datalist>
                            </div>
                            <b-input-group-append>
                              <b-link v-if="cell.type == 'text' && cell.clearable == true
                              " :disabled="!items_[rindex][cell.key]" class="mt-1 mx-2"
                                @click="cell.empty ? items_[rindex][cell.key] = cell.empty : ''; $emit('changed', items_[rindex])"
                                title="Clear">
                                <i class="fa fa-remove text-dark"></i>
                              </b-link>
                            </b-input-group-append>
                          </b-input-group>

                          <b-input-group>
                            <span v-if="cell.type == 'badge'" :class="'text-center badge badge-' +
                              badgecolor(cell.key, items_[rindex][cell.key]) +
                              ' badge-pill badge-flightclass'
                              " :title="items_[rindex][cell.key]">
                              {{ items_[rindex][cell.key] }}
                            </span>
                          </b-input-group>

                          <b-input-group>
                            <b-form-textarea v-if="cell.type == 'textarea'" :title="cell.label" :placeholder="cell.placeholder ? cell.placeholder : null
                              " size="sm" rows="1" max-rows="6" :debounce="debounce"
                              :disabled="cell.disabled == 'true' ? true : null" :class="cell.class ? cell.class : null"
                              v-model="items_[rindex][cell.key]"></b-form-textarea>

                            <b-input-group-append>
                              <b-link v-if="cell.type == 'textarea' &&
                                cell.clearable == 'true'
                              " :disabled="!items_[rindex][cell.key]" class="mt-1 mx-2"
                                @click="items_[rindex][cell.key] = ''" title="Clear">
                                <i class="fa fa-remove text-dark"></i>
                              </b-link>
                            </b-input-group-append>
                          </b-input-group>

                          <i-cinvoice v-if="cell.type == 'icinvoice'" :title="cell.label" :placeholder="cell.placeholder ? cell.placeholder : null
                            " v-model="items_[rindex]" @postit="$emit('click', 'posted', [items_[rindex]]);">
                          </i-cinvoice>

                          <i-linvoice v-if="cell.type == 'ilinvoice'" :title="cell.label" :placeholder="cell.placeholder ? cell.placeholder : null
                            " v-model="items_[rindex]" @postit="$emit('click', 'posted', [items_[rindex]]);">
                          </i-linvoice>

                          <i-binvoice v-if="cell.type == 'ibinvoice'" :title="cell.label" :placeholder="cell.placeholder ? cell.placeholder : null
                            " v-model="items_[rindex]" @postit="$emit('click', 'posted', [items_[rindex]]);">
                          </i-binvoice>

                          <i-ginvoice v-if="cell.type == 'iginvoice'" :title="cell.label" :placeholder="cell.placeholder ? cell.placeholder : null
                            " v-model="items_[rindex]" @postit="$emit('click', 'posted', [items_[rindex]]);">
                          </i-ginvoice>

                          <i-xinvoice v-if="cell.type == 'ixinvoice'" :title="cell.label" :placeholder="cell.placeholder ? cell.placeholder : null
                            " v-model="items_[rindex]" @postit="$emit('click', 'posted', [items_[rindex]]);">
                          </i-xinvoice>

                          <i-tinvoice v-if="cell.type == 'itinvoice'" :title="cell.label" :placeholder="cell.placeholder ? cell.placeholder : null
                            " v-model="items_[rindex]" @postit="$emit('click', 'posted', [items_[rindex]]);">
                          </i-tinvoice>

                          <i-zinvoice v-if="cell.type == 'izinvoice'" :title="cell.label" :placeholder="cell.placeholder ? cell.placeholder : null
                            " v-model="items_[rindex]" @queueit="$emit('click', 'queued', [items_[rindex]]);">
                          </i-zinvoice>

                          <i-reconcile v-if="cell.type == 'ireconcile'" :title="cell.label" :placeholder="cell.placeholder ? cell.placeholder : null
                            " v-model="items_[rindex]" @reconcileit="$emit('click', 'reconcile', [items_[rindex]]);"
                            @unreconcileit="$emit('click', 'unreconcile', [items_[rindex]]);"
                            @go="$emit('click', 'go', [items_[rindex]]);">
                          </i-reconcile>

                          <b-tooltip :target="'row_' + rindex + 'key_' + cell.key" v-if="items_[rindex][cell.key]"
                            placement="top" triggers="hover">{{ items_[rindex][cell.key] }}</b-tooltip>
                      </td>
                    </tr>
                  </table>
                </td>

                <td v-if="toolbar.filter((t) => t.position.includes('actions'))
                  .length > 0
                " class="actions w-50px">
                  <div v-if="row.id">
                    <b-button variant="link" size="sm" v-for="(tool, index) in actionsvalid(row)" :key="tool.action"
                      :title="tool.label" :disabled="tool.disabled" @click.stop="toolClick($event, tool.action, [row])">
                      <i :class="tool.icon" class="text-primary"></i>
                    </b-button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <template #overlay>
            <div class="text-center">
              <p id="cancel-label">{{ overlay.message }}</p>
              <hr />
              <b-row>
                <b-col>
                  <b-button v-for="(button, index) in overlay.buttons" :key="index"
                    :style="button.style ? button.style : 'width: 80px'" :class="button.class
                      ? button.class
                      : button.dispatch
                        ? null
                        : 'ml-2'
                      " :variant="button.variant
                        ? button.variant
                        : button.action
                          ? 'outline-primary'
                          : 'outline-secondary'
                        " :size="button.size ? button.size : 'sm'" :squared="button.squared ? button.squared : true"
                    @click="
                      button.action
                        ? toolClick($event, button.action, checked_items)
                        : (overlay_show = false)
                      ">{{ button.label }}</b-button>
                </b-col>
              </b-row>
            </div>
          </template>
        </b-overlay>
      </div>
    </b-overlay>

    <b-row v-if="showsheets" class="excelsheetbuttons mt-n3">
      <b-col>
        <b-button-group>
          <b-button v-for="(tool, index) in toolbar.filter((t) =>
            t.action.includes('sheet_')
          )" :key="index" :size="tool.size" :variant="tool.variant"
            :title="tool.tooltip ? tool.tooltip : toolLabel(tool)" :id="'sheet_' + tool.action"
            :pressed="table_tab == index" :disabled="tool.disabled" type="button" class="status" @click="
              table_tab = index;
            toolClick(null, tool.action);
            ">
            <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
            {{ tool.label }}
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>

    <!-- </b-overlay>  -->
    <b-row v-if="!component" class="excelsheetbuttons px-0 mt-2 z-0">
      <b-col v-if="!busy" class="text-left" cols="10">
        <span v-if="showrowcount" class="small text-primary">Found {{ rowslabel }}</span><span v-if="showpages"
          class="small text-primary">, {{ pageslabel }}</span>
      </b-col>
      <b-col v-if="showpages" class="text-right ml-auto" cols="auto">
        <b-row>
          <b-col cols="auto">
            <b-pagination hide-ellipsis v-if="rows > 0" v-model="page_" :total-rows="rows" :per-page="limit_"
              :align="'right'" size="sm"></b-pagination>
          </b-col>
          <b-col cols="auto">
            <div class="pagelimit">
              <treeselect v-model="limit_" :clearable="false" :options="options_pagesizes" size="sm" inline>
              </treeselect>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- <Pastespecial /> -->
    <NotesEdit />

    <b-modal id="download-file" v-model="download_show" centered title="Download" @close="handleCancel()"
      :modal-class="{ 'c-dark-theme': $store.state.darkMode }">

      <template #default="{ hide }">

        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-row>
            <b-col cols="12">
              <b-form-group label="Download selection" label-for="type" label-cols="12">
                <treeselect instanceId="download_type" type="number" v-model="download" :clearable="false"
                  :options="options_download" @input="download_change"></treeselect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="File format" label-for="type" label-cols="12">
                <treeselect instanceId="download_format" type="number" v-model="download_file" :clearable="false"
                  :options="options_download_file"></treeselect>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mt-2" cols="12" v-if="downloaded.length == 0">
              <b-row no-gutters>
                <b-col cols="auto"> <i class="fa fa-cog fa-spin text-primary" style="font-size:24px"></i></b-col>
                <b-col class="pl-2"> <span>One moment we are fetching that data for you...</span></b-col>
              </b-row>
            </b-col>
          </b-row>

        </form>
      </template>

      <template #modal-footer="{ ok, cancel, hide }">
        <span v-if="downloaded.length > 0" class="mr=4">Ready to export {{ downloaded.length }} row(s)</span>

        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="outline-primary" @click="handleSubmit()" :disabled="downloaded.length == 0">
          <i :class="downloading ? 'fa fa-refresh fa-spin text-info mr-1' : 'fa fa-download text-info mr-1'"></i>
          <span v-text="downloading ? 'Downloading' : 'Download It'"></span>
        </b-button>
        <b-button size="sm" variant="secondary" @click="handleCancel()">
          <i class="fa fa-chevron-left pr-1"></i>Back
        </b-button>
        <!-- Button with custom close trigger value -->
        <!-- <b-button size="sm" variant="outline-secondary" @click="hide('forget')">
          Forget it
        </b-button> -->
      </template>
    </b-modal>


  </div>
</template>

<script>
import * as toolsetup from "./toolsetup";

const notInArr = function notInArr(item) {
  return this.indexOf(item) === -1;
};

function addCheckedSubset(current, add) {
  if (!current.length) return add;

  // Add only messages which are not already checked
  return current.concat(add.filter(notInArr, current));
}

function removeCheckedSubset(current, remove) {
  // Return only messages which are not in subset
  return current.filter(notInArr, remove);
}

export default {
  name: "e-table",
  props: {
    classdivtable: {
      type: String,
      default:
        "table b-table table-sm table-striped datatable flightstable multiuser",
    },
    title: { type: String, default: "" },
    refid: { type: String, default: "e-table" },
    busy: { type: Boolean, default: false },
    icon: { type: String, default: "fa fa-power-off text-primary" },
    selectmode: { type: String, default: "checkbox" },
    pagesize: { type: Number, default: 15 },
    tools: { type: String, default: "" },
    toolbar: {
      type: Array,
      default() {
        return [];
      },
    },
    toolbarlibrary: {
      type: Array,
      default() {
        return [];
      },
    },
    downloaded: {
      type: Array,
      default() {
        return [];
      },
    },
    fields: {
      type: Array,
      default() {
        return [];
      },
    },
    badges: {
      type: Array,
      default() {
        return [];
      },
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    selectall: { type: Boolean, default: false },
    debounce: { type: Number, default: 500 },
    showtoolbar: { type: Boolean, default: true },
    showfab: { type: Boolean, default: true },
    showsheets: { type: Boolean, default: false },
    showpages: { type: Boolean, default: true },
    showrowcount: { type: Boolean, default: true },
    showautoadd: { type: Boolean, default: false },
    page: { type: Number, default: 1 },
    offset: { type: Number, default: 0 },
    limit: { type: Number, default: 15 },
  },
  mounted() {
    document.addEventListener("keyup", this.keyupHandler);
  },
  destroyed() {
    document.removeEventListener("keyup", this.keyupHandler);
  },
  data() {
    return {
      loaded: false,
      page_: 1,
      limit_: 15,
      items_: [],
      rows: 0,
      table_tab: 0,
      height: 350,
      toolbarlibrary_: toolsetup.default.library,
      fab_bar: false,
      options_pagesizes: [
        { id: 5, label: "5" },
        { id: 10, label: "10" },
        { id: 15, label: "15" },
        { id: 25, label: "25" },
        { id: 50, label: "50" },
        { id: 5000, label: "All" },
      ],
      overlay_show: false,
      overlay: {},
      rows_checked: false,
      checked_items: [],
      download_show: false,
      download: "download_view",
      options_download: [
        { id: "download_view", label: "Current page" },
        { id: "download_all", label: "All pages" },
      ],
      download_file: "download_xlsx",
      options_download_file: [
        { id: "download_xlsx", label: "Excel Workbook (*.xlsx)" },
        { id: "download_txt", label: "Text (Tab delimited) (*.txt)" },
        { id: "download_csv", label: "CSV (Comma delimited) (*.csv)" },
      ],
      downloading: false,
    };
  },
  computed: {
    allAreChecked() {
      const checked = this.checked_items.length;
      return checked === this.items.length;
    },
    actionsfab() {
      let tools = this.toolbar.filter((o) => o.position.includes("toolbar"));

      let fabs = [];
      for (var i = 0; i < tools.length; i++) {
        let tool = tools[i];
        fabs.push({
          name: "tool('" + tool.action + "')",
          // icon: tool.icon_material ? tool.icon_material : "not_listed_location",
          // color: tool.icon_color ? tool.icon_color : null,
          tooltip: tool.label ? tool.label : null,
        });
      }
      return fabs;
    },
    rowslabel() {
      let result = this.rows.toString() + " row"
      if (this.rows == 1) {
        return result
      }
      return result += 's'
    },
    pageslabel() {
      let count = Math.ceil(this.rows / this.limit)
      let result = count.toString() + " page"
      if (count == 1) {
        return result
      }
      return result += 's'
    },
    tableheight() {
      let result = 600
      switch (true) {
        case this.limit == 10:
          result = 350;
          break;
        case this.limit == 15:
          result = 600;
          break;
        case this.limit == 25:
          result = 800;
          break;
        case this.limit == 50:
          result = 1600;
          break;
        case this.limit > 50:
          result = 3600;
          break;
      }
      return result
    }
  },

  watch: {
    // pastebuffer: {
    //   immediate: true,
    //   async handler(newVal, oldVal) {
    //     if (newVal) {
    //       let data = newVal.split(/\r?\n/).filter((e) => e);
    //       for (var j = 0; j < data.length; j++) {
    //         data[j] = data[j].split("\t");
    //       }

    //       if (data.length > 0) {
    //         let columns = data[0];

    //         let result = [];
    //         for (var j = 1; j < data.length; j++) {
    //           let item = { id: "" };
    //           for (var k = 0; k < columns.length; k++) {
    //             let column = columns[k]
    //               .toLowerCase()
    //               .trim()
    //               .split(" ")
    //               .join("");
    //             if (column == "hotel") {
    //               column = "hotelname";
    //             }
    //             let find = this.fields.find((o) => o.key == column);
    //             if (find) {
    //               item[column] = data[j][k];
    //             } else {
    //               if (column == "check-indate") {
    //                 item["datetravel"] = {
    //                   startDate: this.$moment(data[j][k], "DD/MM/YYYY").format(
    //                     "YYYY-MM-DD"
    //                   ),
    //                   endDate: this.$moment(
    //                     data[j][k + 1],
    //                     "DD/MM/YYYY"
    //                   ).format("YYYY-MM-DD"),
    //                 };
    //               }
    //             }
    //           }
    //           result.push(item);
    //         }

    //         this.items = result;
    //       }
    //     }
    //   },
    // },
    items: {
      immediate: true,
      async handler(newVal, oldVal) {
        console.log(this.refid, " watch:items", newVal);

        let result = [];

        let copied = newVal; //JSON.parse(JSON.stringify(newVal))

        this.rows = copied.length;
        for (var j = 0; j < copied.length; j++) {
          let item = copied[j];
          item.index = j + 1;

          delete item["__typename"];
          if (j == 0 && item.rows) {
            this.rows = item.rows;
          }

          if (this.fields) {
            for (var i = 0; i < this.fields.length; ++i) {
              let field = this.fields[i];

              if (field.type == "daterangepicker") {
                if (!item[field.key]) {
                  item[field.key] = { startDate: null, endDate: null };
                }

                if (Array.isArray(item[field.key])) {
                  item[field.key] = {
                    startDate: item[field.key][0],
                    endDate: item[field.key][1],
                  };
                }
              }

              if (field.totalled) {
                field.total = 0;
                if (!field.type) {
                  field.type = "float";
                }
                for (var k = 0; k < newVal.length; ++k) {
                  let row = newVal[k];

                  let value = 0;
                  if (field.type == "int") {
                    value = parseInt(row[field.key]);
                  } else {
                    value = parseFloat(row[field.key]);
                  }
                  if (value >= 0) {
                    field.total += value;
                  } else {
                    field.total -= Math.abs(value);
                  }
                }
                if (field.type == "float") {
                  field.total = Math.round(field.total * 100) / 100;
                  field.total = this.$options.filters.currency(field.total, "");
                }
              }
            }
          }

          result.push(item);
          // if (!this.startat && item.status == "F") {
          //   this.startat = j;
          // }
        }

        // EMPTY LAST
        if (this.showautoadd) {
          let item = { id: "" };
          for (var i = 0; i < this.fields.length; ++i) {
            let field = this.fields[i];
            if (field.type == "daterangepicker") {
              // if (!item[field.key]) {
              item[field.key] = { startDate: null, endDate: null };
              // }
            } else {
              item[field.key] = null;
            }
          }
          result.push(item);
        }
        this.items_ = result;
        this.checked_items = [];
        this.loaded = true

        this.$emit("totalled", this.fields);
        this.$emit("change", this.cleanit(this.items_));
        this.$emit("select", [], this.toolbar);
      },
    },
    checked_items: {
      immediate: true,
      deep: true,
      async handler(newVal, oldVal) {
        this.$emit("select", this.cleanit(newVal), this.toolbar);
      },
    },
    // rows: {
    //   deep: true,
    //   async handler(newVal, oldVal) {
    //     if (newVal) {
    //       // console.log("change", newVal);
    //       this.$emit("change", this.cleanit(newVal));
    //       // if (newVal.length != this.items.length) {
    //       //   newVal[0].rowClass = "uncommitted";
    //       //   let newrows = [...this.rows];
    //       //   if (this.virtualnewrow) {
    //       //     let item = { id: "" };
    //       //     for (var i = 0; i < this.fields.length; ++i) {
    //       //       let field = this.fields[i];
    //       //       if (field.type == "daterangepicker") {
    //       //         // if (!item[field.key]) {
    //       //         item[field.key] = { startDate: null, endDate: null };
    //       //         // }
    //       //       } else {
    //       //         item[field.key] = "";
    //       //       }
    //       //     }
    //       //     newrows.push(item);
    //       //     console.log(newrows)
    //       //     // this.rows = newrows
    //       //   }
    //       // }
    //     }
    //   },
    // },
    toolbarlibrary: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          // ADD NEW TOOLS TO THE INNER toolbar_library
          for (var i = 0; i < newVal.length; i++) {
            let tool = newVal[i];
            if (tool.action) {
              let found = this.toolbarlibrary_.find(
                (o) => o.action == tool.action
              );
              if (!found) {
                if (!tool.disabled) {
                  tool.disabled = true;
                }
                this.toolbarlibrary_.push(tool);
              }
            }
          }
        }
      },
    },
    tools: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          newVal = newVal
            .split("default")
            .join("back,save,filter,go,export,add,edit,deleteconfirm");
          let list = newVal.split(",");

          this.toolbar = []
          for (var i = 0; i < list.length; i++) {
            let found = this.toolbar.find((o) => o.action == list[i]);
            if (!found) {
              let tool = this.toolbarlibrary_.find((o) => o.action == list[i]);
              if (tool) {
                tool.disabled = true;
                tool.visible = true;
                this.toolbar.push({ ...tool });
              }
            }
          }
          this.$emit("select", [], this.toolbar);
        }
      },
    },
    showpages: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          this.height = 350;
        } else {
          this.height = 1000;
        }
      },
    },
    showautoadd: {
      immediate: true,
      async handler(newVal, oldVal) {
        this.items = this.items.filter((i) => i.id);
      },
    },
    page: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (parseInt(newVal) > 0) {
          console.log("e-table page to", newVal);
        }
      },
    },
    limit: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (parseInt(newVal) > 0) {
          if (newVal != this.limit_) {
            this.limit_ = newVal
            await this.setsize(newVal)
          }
        }
      }
    },
    offset: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (parseInt(newVal) == 0) {
          this.page_ = 1
        }
      }
    },
    page_: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (parseInt(newVal) > 0) {
          if (this.loaded) {
            if (newVal != this.page) {
              console.log("e-table page_ to", newVal);
              this.$emit("load", (newVal - 1) * this.limit, this.limit, newVal);
            }
          }
        }
      },
    },
    limit_: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (parseInt(newVal) > 0) {
          if (this.loaded) {
            if (newVal != this.limit) {
              console.log("e-table size_ to", newVal);
              this.$emit("load", 0, newVal, 1);
            }
          }
        }
      },
    },
  },

  methods: {
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleCancel() {
      console.log('you cancelled')
      //Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('download-file')
      })
      this.$emit("load", 0, 15, 1);
    },
    async handleSubmit() {

      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      this.downloading = true

      let file = null
      let buffer = null
      let filename = 'export' + this.$moment().format("_YYYYDDMMHHMMSS")
      switch (this.download_file) {
        case "download_xlsx":
          await this.excel_sheet({ items: this.downloaded, fields: this.fields, });
          break;

        case "download_txt":
          file = await this.outputTXT("\t", this.downloaded);
          buffer = Buffer.from(file, "utf8");
          fs.saveAs(new Blob([buffer], { type: "text/csv;charset=utf-8" }), filename + ".txt");
          break;

        case "download_csv":
          file = await this.outputTXT(",", this.downloaded);
          buffer = Buffer.from(file, "utf8");
          fs.saveAs(new Blob([buffer], { type: "text/csv;charset=utf-8" }), filename + ".csv");
          break;
      }

      this.downloading = false
    },
    async outputTXT(delim, downloaded) {

      if (!delim) {
        delim = "\t"
      }
      let result = "";
      console.log(this.fields)

      let fields = this.fields
      let items = this.items
      if (downloaded) { items = downloaded }

      for (let j = 0; j < items.length; j++) {
        let line = "";

        // HEADER
        if (j == 0) {
          for (let k = 0; k < fields.length; k++) {
            if (fields[k].key == "selected" || fields[k].key == "icon" || fields[k].key == "actions") {
            } else {
              line += fields[k].label + delim;
            }
          }
          if (line.length > 0) {
            line = line.slice(0, -1);
          }
          result += line + "\n";
          line = "";
        }

        let obj = items[j];

        // USE FIELDS IN CASE AN OBJECT IS NOT COMPLETE
        for (let k = 0; k < fields.length; k++) {
          let value = "";
          let prop = ""
          if (fields[k].key == "selected" || fields[k].key == "icon" || fields[k].key == "actions") {
          } else {
            value = obj[fields[k].key] ? obj[fields[k].key] : ""
            console.log(fields[k].key)
            if (
              (this.fields[k].key.toLowerCase().includes('date') ||
                this.fields[k].key.toLowerCase().includes('modified') ||
                this.fields[k].key.toLowerCase().includes('issued') ||
                this.fields[k].key.toLowerCase().includes('invoice_at') ||
                this.fields[k].key.toLowerCase().includes('travel_at') ||
                this.fields[k].key.toLowerCase().includes('start_at')
              ) && !this.fields[k].key.toLowerCase().includes('updated')) {

              if (value) {
                if (!this.$moment(value).isValid()) {
                  value = this.$moment.unix(parseFloat(value) / 1000).utc(false).format("DD/MM/YY")
                }
              }
            }
            if (value) {
              value = value
                .toString()
                .replace(/(\r\n|\n|\r)/gm, "")
                .replace(/""/g, '"');
            }

            prop = fields[k].key.toLowerCase()
            line += value + delim;
          }

        }
        if (line.length > 0) {
          line = line.slice(0, -1);
        }

        result += line + "\n";
      }

      return result;
    },


    download_change() {
      this.$emit("click", this.download, this.toolbar);
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    cleanit(dirty) {
      let cleaned = [];
      for (var j = 0; j < dirty.length; j++) {
        let item = JSON.parse(JSON.stringify(dirty[j]));
        delete item.index;

        let empty = true;
        for (var i = 0; i < this.fields.length; ++i) {
          let field = this.fields[i];

          // DONT REMOVE THE KEY/VALUE ON CLEARABLE
          if (field.type == "treeselect") {
            if (!item[field.key]) {
              console.log(field.key, "is missing");
              item[field.key] = "";
            }
          }

          if (field.type == "daterangepicker") {
            if (item[field.key]) {
              let value = [];
              if (item[field.key].startDate) {
                value.push(
                  this.$moment(item[field.key].startDate).format("YYYY-MM-DD")
                );
                empty = false;
              } else {
                value = "";
              }
              if (item[field.key].endDate) {
                value.push(
                  this.$moment(item[field.key].endDate).format("YYYY-MM-DD")
                );
                empty = false;
              }
              item[field.key] = value;
            }
          } else {
            if (item[field.key]) {
              empty = false;
            }
          }
        }
        if (!empty) {
          cleaned.push(item);
        }
      }
      return cleaned;
    },
    toggleAll(evt) {
      console.log("toggle all", this.allAreChecked);
      const list = this.allAreChecked
        ? []
        : this.items.slice(0, this.items.length);
      this.checked_items = list;
    },
    toggleRow(evt, index) {
      console.log("toggle row", evt, index);

      const savedIndex = this.savedIndex;
      this.savedIndex = index;

      // If this is the first pass or no shift key was
      // pressed, just bail.
      if (savedIndex === null || !evt.shiftKey) return;

      // Shift-clicked the same message :-/
      if (index === savedIndex) return;

      // Get the subset of the message list between the
      // two indicies.
      // console.time("toggle range");
      const subset = this.items.slice(
        Math.min(index, savedIndex),
        Math.max(index, savedIndex) + 1
      );
      // Determine the operation based on the checked state
      // of the clicked checkbox.
      const toggleFn = evt.currentTarget.checked
        ? addCheckedSubset
        : removeCheckedSubset;

      this.checked_items = toggleFn(this.checked_items, subset);
      console.log("these are checked", this.checked_items);
      this.$emit("select", checked_items, this.toolbar);
      // console.timeEnd("toggle range");
    },
    actionsvalid(item) {
      var valid = [];

      let actions = this.toolbar.filter((o) => o.position.includes("actions"));

      for (var i = 0; i < actions.length; i++) {
        let action = actions[i];
        if (action.visible) {
          if (action.rule) {
            var rule = action.rule;
            var op = rule.toString().substring(0, 1);
            var equalTo = true;
            if (op == "!") {
              equalTo = false;
              rule = rule.substring(1);
            }
            if (item.hasOwnProperty(rule)) {
              var state = item[rule];
              if (
                (state == true && equalTo == true) ||
                (state == false && equalTo == false)
              ) {
                valid.push(action);
              }
            } else {
              valid.push(action);
            }
          } else {
            valid.push(action);
          }
        }
      }
      return valid;
    },
    badgecolor(k, v) {
      let r = "white";
      let find = this.badges.find((o) => o.key == k);
      if (find) {
        if (find[v]) {
          r = find[v];
        } else {
          r = "danger";
        }
      }
      return r;
    }, // TOOLBAR HELPERS
    toolLabel(a) {
      switch (a.action) {
        case "filter":
          return this.showfilter ? "Filter On" : "Filter Off";
        case "autoquery":
          return this.autoquery ? "Auto On" : "Auto Off";
        default:
          return a.label;
      }
    },
    async toolClick($event, a, s) {
      console.log("e-table tool: ", $event, a, s);

      this.overlay_show = false;

      // let tool = this.toolbar.find((o) => o.action == a);
      // if (tool.disabled) {
      //   return;
      // }

      switch (a) {
        // case "sheet_0":
        // case "sheet_1":
        // case "sheet_2":
        // case "sheet_3":
        // case "sheet_4":
        // case "sheet_5":
        // case "sheet_6":
        // case "sheet_7":
        // case "sheet_8":
        // case "sheet_9":
        //   break;

        case "filter":
          this.showfilter = !this.showfilter;
          this.$emit("click", a, this.selection, this.toolbar);
          break;

        case "download":
          if (this.items.length > 0) {
            if (!this.download_show) {
              this.download = "download_view"
              this.download_file = "download_xlsx"
              this.downloaded = this.items
            }
            this.download_show = !this.download_show;
          }
          break;

        // case "autoquery":
        //   this.autoquery = !this.autoquery;
        //   break;

        case "cut":
        case "copy":
        case "clipboard":
          this.$store.state.clipboard = this.cleanit(this.checked_items);
          break;

        // case "pastespecial":
        //   // this.$bvModal.show("Pastespecial");
        //   break;

        case "notes":
          this.$bvModal.show("NotesEdit");
          break;

        case "insert":
          this.items.push({ ...this.items[this.items.length - 1] });
          this.items[this.items.length - 1].id = "";
          this.items[this.items.length - 1].line = this.items.length.toString();
          break;

        case "export":
          await this.excel_sheet({
            items:
              this.checked_items.length > 0
                ? this.cleanit(this.checked_items)
                : this.cleanit(this.items),
            fields: this.fields,
          });
          break;

        default:
          let index = 0;
          let item = null;

          console.log("default case", $event, s);

          // LAST SELECTED ITEM IS THE ACTIVE ONE
          this.checked_items = s;
          // let item = null;
          if (s) {
            item = s[0];
          }
          // MIXIN COMPAITBILITY
          this.selection = s;

          let toolactive = this.toolbar.find((o) => o.action == a);
          // CLEAR THE SELECTION IF ADDING!
          if (a == "add") {
            this.selection = [];
          } else {
          }

          this.$emit("click", a, this.selection, this.toolbar);

          if (toolactive.hasOwnProperty("overlay")) {
            if (toolactive.overlay.message) {
              let message = toolactive.overlay.message;

              // IF WE DID NOT ALREADY HAVE IT IN DATA MAKE THE INDEX FROM THE LIST

              if (index == 0 && this.selection.length > 0) {
                message = message.split("row %index%").join(this.selection.length + " row(s)")
              } else {
                for (let prop in item) {
                  if (Object.prototype.hasOwnProperty.call(item, prop)) {
                    message = message.split("%" + prop + "%").join(item[prop]);
                  }
                }
                message = message
                  .split("%index%")
                  .join(this.offset + index);
              }

              this.overlay.message = message;
            }
            if (toolactive.overlay.buttons) {
              this.overlay.buttons = toolactive.overlay.buttons;
            }
            this.overlay_show = !this.overlay_show;
            return;
          }

      }
    },
    bottom(index) {
      let result = 0;
      if (this.fab_bar) {
        if (index == 0) {
          result = 60;
        } else {
          result = 60 + index * 50;
        }
      }
      return result;
    },
    rowIcon(r) {
      let result = this.icon;
      if (!r.id) {
        result = "fa fa-plus text-primary";
      }
      if (r.running == 1 || r.runnow == 1) {
        result += " text-warning";
      } else {
        // result += " text-primary";
      }
      return result;
    },
    async keyupHandler(event) {
      if (event.ctrlKey && event.key === "v") {
        let text = "";
        if (navigator.clipboard) {
          text = await navigator.clipboard.readText();
        }
        console.log(text);
      }
    },

    // copy text TO the clipboard
    // await navigator.clipboard.writeText('This text is now in the clipboard');

    // get text FROM the clipboard
    // let text = await navigator.clipboard.readText();

    pasteHandler(event) {
      var pastedText =
        event.clipboardData.getData("Text") ||
        event.clipboardData.getData("text/plain");

      if (!pastedText && pastedText.length) {
        return;
      }

      // Parse the pasted text from Excel into rows.
      // Pasted text is usually separated by a new line for each row,
      // but a single cell can contain multiple lines, which is what
      // we pars out in the first `replace`.
      //
      // We find all text within double-quotes ('"') which has new
      // lines, and put the text within the quotes into capture
      // groups. For each match, we replace its contents again, by
      // removing the new lines with spaces.
      //
      // Then lastly, once we've joined all the multi line cells, we
      // split the entire pasted content on new lines, which gives
      // us an array of each row.
      //
      // Since Windows usually uses weird line-endings, we need to
      // ensure we check for each of the different possible
      // line-endings in every regexp.
      //
      // It also handles cells which contains quotes. There appears
      // to be two ways this is handled. In Google Docs, quotes within
      // cells are always doubled up when pasting, so " becomes "".
      // In Libre Office, the quotes are not normal quotes, some
      // other character is used, so we don't need to handle it any
      // differently.
      var rows = pastedText
        .replace(
          /"((?:[^"]*(?:\r\n|\n\r|\n|\r))+[^"]+)"/gm,
          function (match, p1) {
            // This function runs for each cell with multi lined text.
            return (
              p1
                // Replace any double double-quotes with a single
                // double-quote
                .replace(/""/g, '"')
                // Replace all new lines with spaces.
                .replace(/\r\n|\n\r|\n|\r/g, " ")
            );
          }
        )
        // Split each line into rows
        .split(/\r\n|\n\r|\n|\r/g);
      console.log(rows);
    },
    async setsize(s) {
      if (this.showpages) {
        if (s == 10) {
          this.height = 350;
        }
        if (s == 15) {
          this.height = 600;
        }
        if (s == 25) {
          this.height = 800;
        }
        if (s == 50) {
          this.height = 1600;
        }
        if (s > 50) {
          this.height = 3600;
        }
      } else {
        this.height = 1000;
      }
    },
  },
};
</script>

<style></style>